"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseConnectionHealthPolicy = /*#__PURE__*/function () {
  function BaseConnectionHealthPolicy(configuration, data) {
    _classCallCheck(this, BaseConnectionHealthPolicy);

    this.minHealth = configuration.minHealth;
    this.maxHealth = configuration.maxHealth;
    this.currentHealth = configuration.initialHealth;
    this.currentData = data.clone();
  }

  _createClass(BaseConnectionHealthPolicy, [{
    key: "minimumHealth",
    value: function minimumHealth() {
      return this.minHealth;
    }
  }, {
    key: "maximumHealth",
    value: function maximumHealth() {
      return this.maxHealth;
    }
  }, {
    key: "health",
    value: function health() {
      return this.maximumHealth();
    }
  }, {
    key: "update",
    value: function update(connectionHealthData) {
      this.currentData = connectionHealthData;
    }
  }, {
    key: "getConnectionHealthData",
    value: function getConnectionHealthData() {
      return this.currentData.clone();
    }
  }, {
    key: "healthy",
    value: function healthy() {
      return this.health() > this.minimumHealth();
    }
  }, {
    key: "healthIfChanged",
    value: function healthIfChanged() {
      var newHealth = this.health();

      if (newHealth !== this.currentHealth) {
        this.currentHealth = newHealth;
        return newHealth;
      }

      return null;
    }
  }]);

  return BaseConnectionHealthPolicy;
}();

exports.default = BaseConnectionHealthPolicy;